import _ from 'underscore';
export default {
    name: 'filterMethods',
    data() {
		return {};
	},
	methods: {
		saveFilters(filters) {
			if(this.$route.name == "PaymentSupplementslist"){
				localStorage.setItem('entityFiltersPSup', JSON.stringify({ filters, entity: this.$route.name }));
			}
			else{
				localStorage.setItem('entityFilters', JSON.stringify({ filters, entity: this.$route.name }));
			}
		},
		loadFilters(currentFilters) {
			if(this.$route.name == "PaymentSupplementslist"){

				if(!localStorage.getItem('entityFiltersPSup')) return currentFilters;
                let entityFilters = JSON.parse(localStorage.getItem('entityFiltersPSup'));
				return entityFilters.entity === this.$route.name ? entityFilters.filters : currentFilters;
			}else{
				if(!localStorage.getItem('entityFilters')) return currentFilters;
                let entityFilters = JSON.parse(localStorage.getItem('entityFilters'));
				return entityFilters.entity === this.$route.name ? entityFilters.filters : currentFilters;
			}
		},
		cleanFilters() {
			localStorage.removeItem('entityFilters');
			localStorage.removeItem('entityFiltersPSup');
		}
    },
};